<template>
  <div id="news-detail">
    <turnBack :content="content" :url="url" />
    <div class="row-nowrap" style="margin-bottom: 3.5rem">
      <div class="flex-1" />
      <div id="main" class="row-nowrap">
        <el-card shadow="always" class="left-box flex-3">
          <div class="title">{{ article.title }}</div>
          <div>
            <div style="display: flex; align-items: center; position: relative">
              <div @click="goToAccount">
                <el-avatar :size="50" :src="authorInfo.avatar"></el-avatar>
              </div>
              <div style="font-size: 14px; margin-left: 5px">
                <div>
                  {{ article.authorName }}
                  <span v-if="authorInfo.tag"
                    :style="{
                      backgroundColor:
                        authorInfo.tag == '官方'
                          ? 'rgb(0, 153, 255)'
                          : 'rgb(0, 204, 0)',
                      color: '#FFF',
                      padding: '3px 6px',
                      borderRadius: '5px',
                    }"
                    >{{ authorInfo.tag }}</span
                  >
                </div>
                <div style="color: #949494; margin-top: 3px">
                  <span
                    >{{ article.categoryName }}
                    {{ moment(article.createTime).format("YYYY-MM-DD") }}
                    发布</span
                  >
                </div>
              </div>
              <div class="fouse" @click="download">+关注</div>
            </div>
            <div style="display: flex; align-items: center"></div>
          </div>
          <div
            class="content"
            style="margin: 1rem 0rem 1rem"
            v-html="article.content"
          />
          <div
            style="
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              margin-bottom: 10px;
            "
          >
            <span style="color: #949494" v-if="!article.showReadNumber"
              >{{ article.readNumber | formatReadNumber }}阅读</span
            >
            <span style="color: #949494" v-if="article.showOrigin"
              >{{article.origin ?(article.origin == 'REPRINT'?'转载':'作者'):'作者'}}:{{
                article.originName ? article.originName : article.authorName
              }}</span
            >
          </div>
          <div style="display: flex; justify-content: space-between">
            <div
              style="
                display: inline-block;
                padding: 0px 15px;
                text-align: center;
              "
            >
              <div style="font-size: 20px; color: green" @click="download">
                <svg-icon icon-class="u1857" />
              </div>
              <div style="font-size: 14px">
                {{ article.likeNumber }}
              </div>
            </div>
            <div
              style="
                display: inline-block;
                padding: 0px 15px;
                text-align: center;
              "
            >
              <div style="font-size: 20px; color: green" @click="download">
                <svg-icon icon-class="u1858" />
              </div>
              <div style="font-size: 14px">
                {{ article.collectionNumber }}
              </div>
            </div>
            <div
              style="
                display: inline-block;
                padding: 0px 15px;
                text-align: center;
              "
            >
              <div style="font-size: 20px; color: green" @click="downloadShare">
                <svg-icon icon-class="u1861" />
              </div>
              <div style="font-size: 14px">
                {{ article.shareNumber }}
              </div>
            </div>
            <div
              style="
                display: inline-block;
                padding: 0px 15px;
                text-align: center;
              "
            >
              <div style="font-size: 20px; color: green" @click="download">
                <svg-icon icon-class="u1860" />
              </div>
              <div style="font-size: 14px">举报</div>
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid #ccc;
              height: 2px;
              margin: 10px -20px 0px;
            "
          ></div>
          <div class="tagDiv">
            标签:
            <span
              class="tagLabel"
              v-for="(item, key) in article.topicLabels"
              :key="key"
              @click="handleTopic(item)"
            >
              {{ item }}
            </span>
          </div>
          <div
            style="
              border-bottom: 1px solid #ccc;
              height: 2px;
              margin: 10px -20px 0px;
            "
          ></div>
          <div>
            <div
              v-for="(item, key) in contentInfoList"
              :key="key"
              @click="handleDetail(item.id)"
              style="display: flex; padding: 6px 0px; margin: 0px -5px"
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-around;
                "
              >
                <div style="font-size: 14px">{{ item.title }}</div>
                <div style="font-size: 12px; color: #949494">
                  {{ item.authorName }}
                  {{ item.readNumber | formatReadNumber }}阅读
                </div>
              </div>
              <div style="margin-left: 5px">
                <img :src="item.cover" style="width: 100px; height: 60px" />
              </div>
            </div>
          </div>
          <div>
            <div
              style="font-size: 20px; margin: 1.5rem 0rem; text-align: center"
            >
              --热门评论--
            </div>
            <div
              style="
                margin-bottom: 1rem;
                padding-bottom: 1rem;
                border-bottom: 1px solid #ccc;
              "
              v-for="(item, key) in article.commentsList"
              :key="key"
            >
              <div style="display: flex">
                <div class="head">
                  <img :src="item.avatar" />
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <div
                    style="color: #949494; font-size: 15px; margin-top: -2px"
                  >
                    {{ item.username }}
                  </div>
                  <div style="color: #949494; font-size: 15px; margin-top: 3px">
                    {{ item.createTime | filterData }}
                  </div>
                </div>
              </div>
              <div style="margin-top: 10px">
                <span>{{ item.content }}</span>
              </div>
            </div>
            <div v-if="this.article.comments === 0">目前还没有评论哦</div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="sendNewComment">
      <el-input
        v-model="commentsParams.content"
        :disabled="!article.commentAble"
        :placeholder="!article.commentAble ? '评论已关闭' : '请输入内容'"
      ></el-input>
      <div style="display: flex; align-items: center">
        <!-- <img
          src="@/assets/img/content/video/icon_chat_send.png"
          @click="sendNewComment"
          alt="logo"
          style="width: 25px; height: 25px; margin: 0px 10px"
        /> -->

        <div
          style="font-size: 26px; color: green; margin: 0px 5px"
          @click="sendNewComment"
        >
          <svg-icon icon-class="u751" />
        </div>
        <div
          style="font-size: 26px; color: green; margin: 0px 5px"
          @click="download"
        >
          <svg-icon icon-class="u1857" />
        </div>
        <div
          style="font-size: 26px; color: green; margin: 0px 5px"
          @click="download"
        >
          <svg-icon icon-class="u1858" />
        </div>
        <div
          style="font-size: 26px; color: green; margin: 0px 5px"
          @click="downloadShare"
        >
          <svg-icon icon-class="u1861" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as request from "@/utils/request";
import turnBack from "@/components/turnBack";
import moment from "moment";
import "moment/locale/zh-cn";

export default {
  head() {
    return {
      title: `${this.article.title ? this.article.title : "资讯"}-`,
      meta: [
        {
          hid: "description",
          name: "description",
          content: `${
            this.article.content
              ? this.article.content.replace(new RegExp("<.+?>", "g"), "")
              : "中国旅游影视传媒有限公司(中国旅游TV，英文简称CTTV)是在中国旅游局监督指导下，信息产业部、商务部、文化部大 力支持下成立的“互联网+旅游”专业综合平台。中国旅游TV始终坚持开拓多 渠道集群发展产业链与多环节增值的完整生态运作体系，立足于移动互联网， 秉持大盘运作的运营理念，借助资深创意策划以及媒体集团联盟优势，打造集 在线视频、网络直播、线上旅游、城市宣传、生活服务、信息集散、全景VR等 功 能于一体的新型旅游综合门户平台。"
          }`,
        },
      ],
    };
  },
  components: {
    turnBack,
  },
  filters: {
    filterData(time) {
      return moment(time).fromNow();
    },
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  data() {
    return {
      article: {
        id: null,
        like: "",
        comments: "",
        create_date: "",
        title: "",
        content: "",
        commentsList: [],
        topicLabels: [],
      },
      authorInfo: {
        avatar: "",
      },
      moment: moment,
      contentInfoList: [],
      recomments: [],
      type: "",
      id: "",
      content: "资讯详情",
      url: "",
      commentsParams: {
        content: "",
        objectId: 0,
        offset: 0,
        toUserId: 0,
        type: ``,
      },
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.type = this.$route.query.type;
    if (this.type) {
      this.commentsParams.type = `TO_${this.type}`;
    } else {
      this.commentsParams.type = `TO_NEWS`;
    }
    this.commentsParams.objectId = this.id;
    if (this.$route.query.recom) {
      this.url = `/?category=${this.$route.query.category}&id=${this.$route.params.id}&recom=${this.$route.query.recom}`;
    } else {
      this.url = `/?category=${this.$route.query.category}&id=${this.$route.params.id}`;
    }
    this.fetchData().then(() => {
      this.initData();
    });
    this.getContentInfo(2);
  },
  created() {},
  methods: {
    async fetchData() {
      let article = {
        id: null,
        like: "",
        comments: "",
        create_date: "",
        title: "",
        content: "",
        commentsList: [],
      };
      let recomments = [];
      let result = {};
      result = await request.getResourceNewsDetail(this.id);
      article = { ...result.data };
      result = await request.getCommentsByTypeById({
        id: this.id,
        type: "TO_NEWS",
      });
      if (result.data) {
        article.comments = result.data.length;
        article.commentsList = result.data.reverse();
      } else {
        article.comments = 0;
        article.commentsList = [];
      }
      this.article = article;
    },
    getContentInfo(val) {
      request.getResourceNewsRecently({ size: val }).then((res) => {
        let arr = res.data.filter((item) => {
          if (item.categoryId == this.article.categoryId) {
            return true;
          }
        });
        if (arr.length > 0) {
          this.contentInfoList = arr[0].news;
        }
      });
    },
    initData() {
      request.getUsersInfoById(this.article.authorId).then((res) => {
        this.authorInfo = res.data;
      });
    },
    selCommentById() {
      request
        .getCommentsByTypeById({
          type: this.commentsParams.type,
          id: this.id,
        })
        .then((res) => {
          this.article.comments = res.data.length;
          this.article.commentsList = res.data.reverse();
        });
    },
    selNewsById() {
      this.article.title = "加载中......";
      this.article.content = "";
      request.getResourceNewsDetail(this.id).then((res) => {
        this.article = { ...this.article, ...res.data };
      });
    },
    sendNewComment() {
      request.createComments(this.commentsParams).then((res) => {
        this.commentsParams.content = "";
        this.selCommentById();
      });
    },
    download() {
      this.$router.push({ path: `/download` });
    },
    downloadShare() {
      this.$notify({
        title: "下载APP",
        message: "请点击右上角，选择在浏览器打开",
      });
      return;
    },
    goToAccount() {
      this.$router.push({
        path: `/account?authorId=${this.article.authorId}`,
      });
    },
    handleTopic(val) {
      request
        .getTopics({
          topic: val,
        })
        .then((res) => {
          if (res.data) {
            this.$router.push({
              path: `/account?topic=${val}`,
            });
          } else {
            this.$router.push({
              path: `/search?content=${val}`,
            });
          }
        });
    },
    handleDetail(id) {
      this.$router.push({
        path: `/news/details/${id}?type=NEWS&category=info`,
      });
    },
  },
};
</script>

<style lang="less" scope>
#news-detail {
  .row-nowrap {
    #main {
      h1 {
        text-align: center;
      }
      .right-box {
        margin: 0rem 1rem;
        .news-title {
          border-bottom: 1px solid #f4f4f4;
          margin: 1.5rem 0;
          &:hover {
            color: coral;
          }
        }
      }
      .title {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 10px;
      }
      .fouse {
        position: absolute;
        top: 5px;
        right: 10px;
        height: 30px;
        width: 80px;
        background: rgb(0, 153, 255);
        color: #fff;
        border-radius: 5px;
        text-align: center;
        line-height: 30px;
      }
    }
  }
}
.head {
  cursor: pointer;
  width: 3.5rem;
  height: 3rem;

  img {
    height: 3rem;
    width: 3rem;
    border-radius: 50%;
  }
}
.content {
  border: none;
}
.content p {
  width: 100%;
  margin: 5px 0px;
}
.content img {
  width: 100%;
}
.sendNewComment {
  position: fixed;
  width: 100%;
  bottom: 0px;
  display: flex;
  padding: 0.5rem;
  background: #eee;
  height: 3.5rem;
}
</style>

